import { pilot } from '~/services/serviceInstances';

interface Request {
  folderId?: string;
  clientId: string;
}

interface ServerResponse {
  folder_access_list: {
    members: any[];
    departments: any[];
  };
  visibility_level: string;
  can_modify_folder: boolean;
}

export const getFolderAccessList = async ({ folderId, clientId }: Request) => {
  const url = folderId
    ? `/folder/visibility/${folderId}/`
    : '/folder/visibility/';

  const params = {
    client_id: clientId,
  };

  const response: ServerResponse = await pilot.get(url, {
    params,
  });

  return {
    folderAccessList: {
      members: response.folder_access_list.members,
      departments: response.folder_access_list.departments,
    },
    visibilityLevel: response.visibility_level,
    canModifyFolder: response.can_modify_folder,
  };
};
